import { LoadingBone, SkeletonLoaderWidget } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LabelsPopoverContext, buildLabelsPopoverContext } from './LabelHelpers';
import { LabelPopoverContentStyle } from './Styles';
import { CertificationPopover } from './certification/CertificationPopover';
import { CertificationRenderProps, HydratedCertificationRenderProps } from './certification/CertificationProps';
import { SensitivityPopover } from './sensitivity/SensitivityPopover';
import { HydratedSensitivityRenderProps, SensitivityRenderProps } from './sensitivity/SensitivityProps';
import { UsePopoverContentProps } from './shared/useControlledPopover';
import { WarningPopover } from './warning/WarningPopover';
import { HydratedWarningRenderProps, WarningRenderProps } from './warning/WarningProps';


const labelPlaceholder = (<div>
  <LoadingBone />
  <div>
    <LoadingBone style={{ marginBottom: '1rem' }} />
    <div>
      <LoadingBone />
      <LoadingBone />
    </div>
  </div>
</div>);


function LabelPopoverInner(props: HydratedCertificationRenderProps | HydratedWarningRenderProps | HydratedSensitivityRenderProps): JSX.Element {
  switch (props.category) {
    case 'certification': return (<CertificationPopover {...props} />);
    case 'warning': return (<WarningPopover {...props} />);
    case 'sensitivity': return (<SensitivityPopover {...props} />);
  }
}

function renderLabelPopoverLoaded(props?: CertificationRenderProps | WarningRenderProps | SensitivityRenderProps): JSX.Element {
  if (!props || props.kind === 'dehydrated') {
    return <LabelMissing />
  }
  return (
    <LabelsPopoverContext.Provider value={buildLabelsPopoverContext(props)}>
      <LabelPopoverInner {...props} />
    </LabelsPopoverContext.Provider>
  )
}

function LabelMissing(): JSX.Element {
  return (<div>
    {Messages.LabelRetrievalFailure()}
  </div>
  )
}

export function LabelPopover({ resolved, loading }: UsePopoverContentProps<CertificationRenderProps | WarningRenderProps | SensitivityRenderProps>): JSX.Element {
  return (
    <SkeletonLoaderWidget isPending={!resolved || loading} fallback={labelPlaceholder} style={LabelPopoverContentStyle}>
      {renderLabelPopoverLoaded(resolved)}
    </SkeletonLoaderWidget>
  )
}
